import {
  isEligibleForMedAfterZipcodeQuestion,
  isZipcodeCorrespondingToUSState,
} from "src/utils/userSegment/features";

export type ZipcodeEligibilityStatus =
  | "valid"
  | "stateAndConditionIneligible"
  | "stateIneligible";

export function getZipcodeEligibilityStatus(): ZipcodeEligibilityStatus {
  if (!isEligibleForMedAfterZipcodeQuestion()) {
    return "stateAndConditionIneligible";
  }
  if (!isZipcodeCorrespondingToUSState()) {
    return "stateIneligible";
  }
  return "valid";
}
